import React from 'react';

import { Typography } from '@mui/material';

import TabPanelShell from './TabPanelShell';

interface Props {
  configuredFieldCount?: number;
  title: string;
}

export default function PlaceholderTab({ configuredFieldCount, title }: Props) {
  return (
    <TabPanelShell title={title}>
      <Typography color="text.secondary" variant="body2">
        {configuredFieldCount ? `${configuredFieldCount} field skeletons pending.` : 'Field skeleton pending.'}
      </Typography>
    </TabPanelShell>
  );
}
